import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { updateSelectedFilters } from 'store/actions/filters'
import FilterTitle from 'components/ui/FilterTitle'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'

function SearchableMultiSelect({
  type,
  macroType,
  filterData,
  values,
  title,
  showFilter,
  keyWord,
  customTop,
  selection
}) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const filterObject = macroType
    ? filters.selectedFilters[currentSearchable][macroType][type]
    : filters.selectedFilters[currentSearchable][type]
  return (
    <PureSearchableMultiSelect
      type={type}
      macroType={macroType}
      filterData={filterData}
      values={values}
      title={title}
      showFilter={showFilter}
      keyWord={keyWord}
      customTop={customTop}
      filterObject={filterObject}
      selection={selection}
    />
  )
}

const PureSearchableMultiSelect = React.memo(function PureSearchableMultiSelect({
  type,
  macroType,
  filterData,
  values,
  title,
  showFilter,
  keyWord,
  customTop,
  filterObject,
  selection
}) {
  const dispatch = useDispatch()

  const selectedValues = filterObject[values[0]]

  const options = filterData
    ? filterData.map(option => {
        const parentOption = {
          label: option[keyWord],
          value: option.id,
          expanded: true
        }
        const selectedOption = selectedValues.filter(
          s => s.id === option.id && s.label === option[keyWord]
        )
        if (selectedOption.length > 0) {
          parentOption.checked = true
        }
        return parentOption
      })
    : []

  const onChange = (currentNode, selectedNodes) => {
    const filterValue = selectedNodes.map(node => ({
      id: node.value,
      label: node.label
    }))

    const data = {
      filterType: type,
      filterMacroType: macroType,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      resultingValue = filterObject[filterId].filter(
        s => s.id !== filterValue.id || s !== filterValue
      )
    }
    const data = {
      filterType: type,
      filterMacroType: macroType,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (filterObject[value]) {
        const filterValue = filterObject[value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v.id ? v.id : v}>
              <SelectedFilter>
                <FilterText title={v.label ? v.label : v}>
                  <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.label ? v.label : v}</Dotdotdot>
                </FilterText>
                <RemoveIcon
                  className="far fa-times"
                  onClick={() => handleFilterRemove(value, v, true)}
                />
              </SelectedFilter>
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }

  return (
    <>
      {!selection ? (
        <SearchFilter open={showFilter} customTop={customTop}>
          <div className="sticky-container">
            {title ? <FilterTitle>{title}</FilterTitle> : null}
            <CustomDropDownTreeSelect data={options} onChange={onChange} />
          </div>
        </SearchFilter>
      ) : (
        <div className="selected-fl">{renderSelectedValues()}</div>
      )}
    </>
  )
})

SearchableMultiSelect.propTypes = {
  type: PropTypes.string,
  macroType: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  keyWord: PropTypes.string,
  customTop: PropTypes.string,
  selection: PropTypes.bool
}

PureSearchableMultiSelect.propTypes = {
  type: PropTypes.string,
  macroType: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  keyWord: PropTypes.string,
  customTop: PropTypes.string,
  filterObject: PropTypes.object,
  selection: PropTypes.bool
}

export default SearchableMultiSelect
